import { render, staticRenderFns } from "./register.vue?vue&type=template&id=5ba6975b&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=5ba6975b&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/page/register.less?vue&type=style&index=1&id=5ba6975b&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba6975b",
  null
  
)

export default component.exports